if (!customElements.get('subscription-price')) {
    customElements.define('subscription-price', class SubscriptionPrice extends HTMLElement {
      constructor() {
        super();
        this.fetchSubscriptionPrice();
      }
  
      fetchSubscriptionPrice() {
        console.log('fetching subscription price');
        const scriptTag = document.getElementById('recharge-products-data');
        if (!scriptTag) return;
        
        try {
          const rechargeProducts = JSON.parse(scriptTag.textContent);
          if (!rechargeProducts) return;
          
          const productId = this.getAttribute('data-product-id');
          const variantId = this.getAttribute('data-variant-id');
          const sectionId = this.getAttribute('data-section-id');
          
          const product = rechargeProducts.find(p => p.external_product_id == productId);
          if (!product) {
              this.disableSubscribeButton();
            return;
          };
          
          const variant = product.variants.find(v => v.id.toString() == variantId);
          if (!variant) {
            this.disableSubscribeButton();
            return;
          };
          
          let discountedPrice = 'N/A';
          if (variant.discounted_price) {
            discountedPrice = '£' + parseFloat(variant.discounted_price).toFixed(2);
          } else {
            this.disableSubscribeButton();
            return;
          }
          const sellingPlanId = variant?.selling_plan_allocations[0]?.selling_plan_id;
          if (!sellingPlanId) {
            this.disableSubscribeButton();
            return;
          };
          
          if (this.textContent !== discountedPrice) {
            this.textContent = discountedPrice;
            
            this.setAttribute('data-selling-plan-id', sellingPlanId);

            // const classMatch = document.querySelector(
            //   `.bs-devshop__purchase-price.bs-devshop__purchase-price--subscribe[data-product-id="${productId}"][data-variant-id="${variantId}"][data-mobile]`
            // );
            // console.log("classMatch", classMatch);
            // if (classMatch) {
            //   classMatch.textContent = discountedPrice + " /";
            // }
            
            if (sectionId) {
              this.updateSectionPrices(sectionId, rechargeProducts);
            }
          }
        } catch (error) {
          console.error('Error updating subscription price:', error);
        }
      }

      updateSectionPrices(sectionId, rechargeProducts) {
        fetch(`${window.location.pathname}?section_id=${sectionId}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const sectionPrices = doc.querySelectorAll('subscription-price');
            
            sectionPrices.forEach(newPrice => {
              const productId = newPrice.getAttribute('data-product-id');
              const variantId = newPrice.getAttribute('data-variant-id');
              
              // Find the specific product and calculate its price
              const product = rechargeProducts.find(p => p.external_product_id == productId);
              if (!product) return;
              
              const variant = product.variants.find(v => v.id.toString() == variantId);
              if (!variant) return;
              
              let productDiscountedPrice = 'N/A';
              if (variant.discounted_price) {
                productDiscountedPrice = '£' + parseFloat(variant.discounted_price).toFixed(2);
              }
              
              // Find corresponding price element in current DOM
              const currentPrice = document.querySelector(
                `subscription-price[data-product-id="${productId}"][data-variant-id="${variantId}"]`
              );
              if (currentPrice) {
                currentPrice.textContent = productDiscountedPrice;
              }
              
              // Update mobile price if it exists
              // const mobilePrice = document.querySelector(
              //   `.bs-devshop__purchase-price.bs-devshop__purchase-price--subscribe[data-product-id="${productId}"][data-variant-id="${variantId}"][data-mobile]`
              // );
              // if (mobilePrice) {
              //   mobilePrice.textContent = productDiscountedPrice + " /";
              // }
              
              // If price is N/A, disable the subscription button
              if (productDiscountedPrice === 'N/A') {
                const subscribeButtons = document.querySelectorAll(
                  `button.bs-devshop__subscribe[data-variant-id="${variantId}"]`
                );
                subscribeButtons.forEach(button => {
                  button.setAttribute('disabled', 'true');
                  button.classList.add('disabled');
                });
              }
            });
          })
          .catch(error => {
            console.error('Error updating section prices:', error);
          });
      }

      disableSubscribeButton() {
        this.textContent = 'null';
        this.setAttribute('data-selling-plan-id', 'null');  
        this.style.display = 'none';
        if (this.closest('button')) {
          this.closest('button').classList.add('disabled');
        }
      }
    });
  }
  
  window.addEventListener('recharge:products:loaded', () => {
    document.querySelectorAll('subscription-price').forEach(element => {
      element.fetchSubscriptionPrice();
    });
  });